import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {useSearchParams} from 'react-router-dom';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import './style.scss';
import {useAuth} from '../../../contexts/UserContext';
import ReportQuerySelector from '../../organisms/ReportQuerySelector';
import clone from 'clone';
import VenueReportDevices from './VenueReportDevices';
import VenueReportTracks from './VenueReportTracks';
import VenueReportOffline from './VenueReportOffline';
import VenueReportGraph from './VenueReportGraph';

import {
  ReportContextProvider,
  useReport,
} from '../../../contexts/ReportContext';

const Page = styled.div`
  padding-top: 43px;
  @media ${config.layout.wide} {
    padding-top: 75px;
  }
`;

const PageFeatureTitle = styled.div`
  height: 81px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  position: relative;
  display: flex;
  align-items: center;
  @media ${config.layout.wide} {
    height: 93px;
  }

  h2 {
    font-size: 30px;
    font-weight: bold;
    line-height: 39px;
    @media ${config.layout.wide} {
      font-size: 40px;
    }
  }
`;

const VenueNameSection = styled.div`
  padding: 30px 0;
  @media ${config.layout.wide} {
    padding-bottom: 40px;
  }
`;

const VenueNameLabel = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
`;

const VenueNameValue = styled.div`
  font-weight: bold;
  font-size: 50px;
  line-height: 66px;
  margin-top: 10px;
`;

const StatsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media ${config.layout.wide} {
    flex-direction: row;
    align-items: stretch;
    gap: 25px;
    justify-content: space-between;
  }
  margin-bottom: 30px;
  margin-top: 40px;

  & > * {
    width: 100%;
    @media ${config.layout.wide} {
      width: calc((100% - 50px) / 3);
    }

    button.dark-button.stats-action {
      max-width: 200px;
    }
  }
`;

let defaultYear = new Date().getFullYear();
let defaultMonth = new Date().getMonth() + 1;
//defaultMonth--;
if (defaultMonth == 0) {
  defaultMonth = 12;
  defaultYear--;
}

function PeriodSelector({query, onChange}) {
  const onQueryChanged = (newQuery) => {
    onChange(clone(newQuery));
  };

  return (
      <ReportQuerySelector query={query} onChange={onQueryChanged}/>
  );
}

function getValidYearMonthRange() {
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;

  return {
    min: {
      year: 2017,
      month: 1,
      monthID: 2017 * 12 + 1,
    },
    max: {
      year,
      month,
      monthID: year * 12 + month,
    },
  };
}

function ReportPageContent() {
  const report = useReport();
  const app = useApp();
  let [searchParams, setSearchParams] = useSearchParams();
  let [query, setQuery] = useState({
    year: defaultYear,
    month: defaultMonth,
  });

  const changeTimerRef = useRef(null);

  let year = searchParams.get('year') || 0;
  let month = searchParams.get('month') || 0;

  if (year) {
    year = parseInt(year, 10);
    if (!year || year < 2017 || new Date().getFullYear() < year) {
      year = 0;
    }
  }
  if (month) {
    month = parseInt(month, 10);
    if (!month || month < 1 || 12 < month) {
      month = 0;
    }
  }
  let monthID = year * 12 + month;
  let validRange = getValidYearMonthRange();

  if (monthID < validRange.min.monthID) {
    year = defaultYear;
    month = defaultMonth;
  }

  if (query.year != year || query.month != month) {
    setQuery({
      year,
      month,
    });
  }

  const updateParams = () => {
    window.blockAutoScroll();
    if (
        query.year != searchParams.get('year') ||
        query.month != searchParams.get('month')
    ) {
      setSearchParams(
          {
            year: query.year,
            month: query.month,
          },
          {replace: !searchParams.get('year')},
      );
    }
  };
  useEffect(() => {
    updateParams();

    //console.log(venueReport);
    if (changeTimerRef.current) {
      clearTimeout(changeTimerRef.current);
    }
    changeTimerRef.current = setTimeout(() => {
      report.doQuery(query);
    }, 100);
  }, [query]);

  useEffect(() => {
    app.showHeader();
    document.title = 'Report';
  }, []);

  const onQueryChanged = (newQuery) => {
    console.log('new Query', newQuery);
    setSearchParams(
        {
          year: newQuery.year,
          month: newQuery.month,
        },
        {replace: false},
    );
    setQuery({
      ...newQuery,
    });
  };

  return (
      <>
        <PeriodSelector query={query} onChange={onQueryChanged}/>
        <StatsArea>
          <VenueReportTracks/>
          <VenueReportDevices/>
          <VenueReportOffline/>
        </StatsArea>
        <VenueReportGraph/>
      </>
  );
}

export default function ReportPage() {
  const {state} = useAuth();
  const venue = state.venue || null;
  if (!venue) {
    return '';
  }

  return (
      <Page>
        <PageFeatureTitle>
          <h2>Dashboard</h2>
        </PageFeatureTitle>
        <VenueNameSection>
          <VenueNameLabel>Venue Name</VenueNameLabel>
          <VenueNameValue>{venue.name}</VenueNameValue>
        </VenueNameSection>
        <LabelWithInfo
            text={'Period'}
            labelclassname={'report-label-info'}
            style={{
              marginTop: 0,
              marginBottom: 30,
            }}
        >
          <div>
            Select the report term to display.
          </div>
        </LabelWithInfo>
        <ReportContextProvider>
          <ReportPageContent/>
        </ReportContextProvider>
      </Page>
  );
}
